export default __webpack_public_path__ + "static/media/t-bone-dog-about.9c82799f.png";